<template>
    <div :class="preCls + 'content-box'">
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.name"
                    placeholder="请输入组织机构名称"
                    style="margin-left: 10px"
                    @search="search"
                >
                </table-searcher>
            </template>
            <Button
                v-if="$can('add') && !list.length"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
            >
                新增
            </Button>
        </table-tool-bar>
        <tree-table
            ref="mt"
            :columns="columns"
            :data="tree"
            :loading="loading"
            :height="mtHeight"
            @on-toggle-expand="toggleExpand"
        >
            <template v-slot:action="{ row }">
                <Button
                    v-if="$can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickInfo(row)"
                    >修改</Button
                >
                <PoptipButton
                    v-if="$can('delete') && row.sys === 0"
                    text="删除"
                    transfer
                    placement="top-end"
                    type="default"
                    title="您确定删除这条记录吗？"
                    :ok="() => rowConfirmdelete(row)"
                ></PoptipButton>
            </template>
        </tree-table>
        <!-- 弹出层 -->
        <smart-modal
            :maskClosable="maskClosable"
            :title="roleId ? '组织机构详情' : '新增组织机构'"
            :height="350"
            :width="600"
            v-model="showRoleForm"
            @close-by-confirm="fetch"
        >
            <role-form v-if="showRoleForm" :pid="pid" :id="roleId"></role-form>
        </smart-modal>
    </div>
</template>
<script>
import { mapCell } from '_c/grid/renderCell'
import { orgList, orgDelete } from '@/api/sys-org'
import { listToTree } from '_u/helper'
import RoleForm from './form'
import Dict from '_u/dict'
import Enum from '_u/enum'

const PAGE_SIZE = 20
export default {
    components: {
        RoleForm,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                name: '',
            },
            list: [],
            dict: {
                org_level: Dict.NULL,
            },
            modal: {},
            foldMap: [], //{id: "", expand: true}
            maskClosable: false,
            showRoleForm: false,
            roleId: '',
            pid: '0',
        }
    },

    computed: {
        columns() {
            return [
                {
                    key: 'name',
                    title: '组织机构名称',
                    align: 'left',
                    minWidth: 100,
                },
                {
                    title: '组织机构类型',
                    key: 'orgLevel',
                    align: 'left',
                    render: mapCell(this.dict.org_level.val()),
                },
                {
                    key: 'remark',
                    title: '备注',
                    align: 'left',
                    minWidth: 120,
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    render: this.action,
                    minWidth: 120,
                },
            ]
        },
        tree() {
            return listToTree(this.list, { id: 'id', pId: 'pid' })
        },
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                40
        })
    },

    methods: {
        toggleExpand(el) {
            let obj = this.foldMap.find((val) => val.id === el.data.id)
            if (obj) {
                obj.expand = el._isExpand
            } else {
                this.foldMap.push({ id: el.data.id, expand: el._isExpand })
            }
        },

        authResources() {},

        changeStatus(row) {
            roleEnabled(row.id)
                .then(() => {
                    this.$Message.success(this.$t('tips.update.success'))
                })
                .finally(() => this.fetch())
        },

        fetch() {
            this.loading = true
            orgList(this.filter)
                .then((args) => {
                    this.setTableData(args.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.fetch()
        },

        setTableData(data) {
            let list = data.list
            this.foldMap.forEach((el) => {
                let obj = list.find((val) => val.id === el.id)
                if (obj) {
                    obj.expand = el.expand
                }
            })
            this.list = list
        },

        fillData(args) {
            var [role] = args
            this.setTableData(role.data)
        },

        onClickAdd(name, row) {
            if (name === 'same') {
                this.pid = row.pid
            } else if (name === 'son') {
                this.pid = row.id
            }
            this.roleId = ''
            this.showRoleForm = true
        },

        rowClickInfo(row) {
            this.roleId = row.id
            this.pid = row.pid
            this.showRoleForm = true
        },

        rowConfirmdelete(row) {
            this.loading = true
            orgDelete(row.id)
                .then(() => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        },

        action(h, { row, index }) {
            var addDropDown
            addDropDown = (
                <Dropdown
                    onOn-click={(name) => this.onClickAdd(name, row)}
                    placement="left"
                >
                    <Button
                        type="default"
                        size="small"
                        style={{ marginRight: '5px' }}
                    >
                        新增
                    </Button>
                    <DropdownMenu
                        slot="list"
                        style={{
                            minWidth: '60px',
                            padding: 0,
                            textAlign: 'center',
                        }}
                    >
                        <DropdownItem name={'same'}>平级组织机构</DropdownItem>
                        <DropdownItem name={'son'}>子级组织机构</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            )
            return (
                <div>
                    {this.$can('add') ? addDropDown : ''}
                    {this.$can('view') ? (
                        <Button
                            type="default"
                            size="small"
                            style={{ marginRight: '5px' }}
                            onClick={() => this.rowClickInfo(row)}
                        >
                            详情
                        </Button>
                    ) : (
                        ''
                    )}
                    {this.$can('delete') ? (
                        <PoptipButton
                            text="删除"
                            type="default"
                            title="您确定删除这条记录吗？"
                            ok={() => this.rowConfirmdelete(row)}
                            placement={index == 0 ? 'right' : 'top'}
                        >
                            删除
                        </PoptipButton>
                    ) : (
                        ''
                    )}
                </div>
            )
        },
    },

    created() {
        Promise.all([Dict.get(['org_level'])]).then((args) => {
            var [dictGroup] = args
            this.dictGroup = dictGroup
            Object.keys(this.dict).forEach((name) => {
                this.dict[name] = dictGroup[name]
            })
        })
        this.fetch()
    },
}
</script>
